import { ParsedTestCard, SampleType } from "@app/provider/testData/types";

export const getSalivaTestCards = (
  testCards: ParsedTestCard[]
): ParsedTestCard[] =>
  testCards.filter(
    (testCard: ParsedTestCard): boolean =>
      !!testCard.sampleType && [SampleType.SALIVA].includes(testCard.sampleType)
  );
